import { CircleHelp } from "lucide-react";
import { Button } from "@repo/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@repo/ui/tooltip";

interface HelpTooltipProps {
  title: string;
  summary: string;
  details?: string;
  examples?: string[];
  side?: "top" | "right" | "bottom" | "left";
}

export function HelpTooltip({
  title,
  summary,
  details,
  examples,
  side = "top",
}: HelpTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={150}>
        <TooltipTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-5 w-5 text-muted-foreground hover:text-foreground"
            aria-label={title}
            title={summary}
          >
            <CircleHelp className="h-3.5 w-3.5" />
          </Button>
        </TooltipTrigger>
        <TooltipContent
          side={side}
          className="max-w-sm space-y-1.5 max-h-64 overflow-auto text-xs leading-relaxed"
        >
          <p className="font-semibold">{title}</p>
          <p>{summary}</p>
          {details ? <p className="text-muted-foreground">{details}</p> : null}
          {examples && examples.length > 0 ? (
            <div className="pt-1">
              {examples.map((example) => (
                <p key={example} className="text-muted-foreground">
                  {example}
                </p>
              ))}
            </div>
          ) : null}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
